import * as Styled from "../CreateEventPage.styles";

import { Typography, useTheme } from "@mui/material";

import ChipListInputDropDown from "../../../components/ChipListInputDropdown/ChipListInputDropDown";

const PrimaryContactSection = ({ formMethods, users }: any) => {
  const theme = useTheme();

  return (
    <Styled.FormSectionContainer>
      <Typography variant="h3">Primary Contact(s)</Typography>
      <Typography
        variant="subtitle1"
        style={{
          color: theme.colors.neutral.darkGray,
          marginTop: theme.spacing(1),
        }}
      >
        Use the field below to search and select additional employees to add as event contacts. Be advised, these contacts cannot manage the event in Gather, but a Super Admin can support if needed.
      </Typography>
      <ChipListInputDropDown
        name="primaryContacts"
        control={formMethods.control}
        label="Primary Contact(s)"
        required
        placeholder="Start typing a name..."
        fullWidth
        options={users}
      />
    </Styled.FormSectionContainer>
  );
};

export default PrimaryContactSection;
